import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'business/constants';
import { RQAPICallWithData } from 'store/APIClient';

import type { TableSynopsis } from '../types';

export const useAPIGetTableSynopsis = (table: string, enabled = true) =>
    useQuery({
        queryKey: ['datacatalog-table-synopsis', table],
        queryFn: async () => {
            const response = await RQAPICallWithData<TableSynopsis>({
                endpoint: `graph/table_synopsis/${table}`,
                method: 'GET',
            });
            return response.content.data;
        },
        staleTime: STALE_TIME,
        enabled,
    });
